import { createContentPropTypes } from '../../../helpers/content';

const content = {
	wrapperTitle: 'Payment and transfers',
	title: 'Collect payments using Bacs Direct Debit',
	shortDescription:
		'Bacs Direct Debit is the simple, secure and affordable way to collect regular payments like subscriptions and memberships.',
	fullDescription:
		'Complete the details below to set up your payment collection and submit it to Bacs for processing. Please note that Bacs payments must be set up and authorised by 5.10pm to meet your planned submission and collection dates.',
	addPayeeButtonTitle: 'Add new payee',
	noSearchResultMessage: 'No results',
	payeeSingularCountMessage:
		'Collecting more than one payment today? Select multiple payees or accounts to process them all in one transaction.',
	copyToAllButton: 'Apply to all',
	addButton: 'Add another payment or transfer',
	submissionDatePopperBody:
		'This is the date you’re planning to submit your payment to Bacs for processing. Please note that Bacs payments can’t be submitted on a weekend or bank holiday.',
	settlementDatePopperBody:
		'This is the date the money will come out the payer’s account and reach your account – if the payment request is completed and authorised on time.',
	bacsIdPopperBody:
		'This is the service user number that was issued to your company by Bacs. If you have more than one ID, simply select the one you want to use for this payment. ',
	paymentNamePopperBody:
		'Personalise this Bacs payment by giving it a unique name (such as ‘May wages’). This is the name that’ll appear on your payment history and when authorisation is required.',
	paymentsLimitMessage: 'You’ve now reached the maximum amount of Payees that you can process at the one time.',
	continueButtonText: 'Continue',
	amountInvalid: 'Enter the amount you want to move',
	paymentNameInvalid: 'Enter a payment name',
	maxLimitExceededMessage: 'This exceeds the maximum amount of money you can move online per transaction.',
	bacsIdInvalid: 'Please select a Bacs ID',
	fromLabel: 'From',
	toLabel: 'To',
	submissionDateLabel: 'Submission Date',
	submissionDateDescription: 'When your payment request will be sent to Bacs',
	settlementDateLabel: 'Collection Date',
	settlementDateDescription: 'When the money will reach your account',
	paymentNameLabel: 'Payment Collection Name',
	paymentNameDescription: 'You can give this payment a unique name ',
	paymentNameRequirements: 'Max 18 characters',
	bacsIdLabel: 'Bacs ID',
	bacsIdDescription: 'The service user number issued by Bacs',
	referenceLabel: 'Reference',
	amountLabel: 'Amount',
	transactionCodeLabel: 'Transaction Code',
	referenceLabelTemplate: 'Reference (optional)',
	amountLabelTemplate: 'Amount (optional)',
	transactionCodeLabelTemplate: 'Transaction Code (optional)',
	transactionCodePopperBody: 'Please select the relevant transaction code for this Bacs payment collection.',
	transactionCodeInvalid: 'Please select one of the options to continue.',
	referenceInvalid: 'Enter a reference',
	sameRefPopoverMsg:
		'We couldn’t apply this change to every reference as some references can’t be edited or left blank.',
	templateTitle: 'Create Bacs payment template',
	templateEditTitle: 'Edit Bacs payment template',
	templateDescription:
		'Set up your Bacs payment template by adding all the payees and payment details you want to include. Once your template’s been created and saved, you can make changes at any time. Please note that any templates you create here will only be available when you’re making a Bacs payment.',
	templateMakePaymentDescription:
		'Collect a Direct Debit payment quickly and simply using the details you’ve saved in your template. You can make one-off changes for this payment below, but if you want to make permanent changes to your template, you’ll have to go back and edit it. Please remember that Bacs payments must be set up and authorised by 5.10pm to meet your planned submission and settlement dates',
	saveTemplateButtonText: 'Save',
	saveTemplateAndExitButtonText: 'Save and exit',
	saveTemplateAndMakePaymentButtonText: 'Save and make payment',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
